export default __webpack_public_path__ + "static/media/products-doors.dbb4f75e.jpg";